import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxEditorModule } from 'ngx-editor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from '../../projects/auth/src/lib/auth.module';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import {
  DatePipe,
  NgOptimizedImage,
  registerLocaleData,
} from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
} from '@angular/common/http';
import { VendorsModule } from '../../projects/vendors/src/lib/vendors.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home/home.component';
import { SystemSettingsComponent } from './home/containers/system-settings/system-settings.component';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import {
  KeycloakAngularModule,
  KeycloakBearerInterceptor,
  KeycloakService,
} from 'keycloak-angular';
import { RawMaterialNamePipe } from '../../projects/vendors/src/lib/pipe/raw-material-name.pipe';
import { StoreModule } from '@ngrx/store';
import * as fromApp from './app.reducer';
import { FoodItemPipe } from '../../projects/vendors/src/lib/pipe/food-item.pipe';
import { TableNamePipe } from '../../projects/vendors/src/lib/pipe/table-name.pipe';
import { SectionNamePipe } from '../../projects/vendors/src/lib/pipe/section-name.pipe';
import { OngoingOrdersComponent } from './home/containers/ongoing-orders/ongoing-orders.component';
import { CheckOutDialogBoxComponent } from './home/containers/ongoing-orders/check-out-dialog-box/check-out-dialog-box.component';
import { OrderDeleteDialogComponent } from './home/containers/ongoing-orders/order-delete-dialog/order-delete-dialog.component';
import { UpdateFoodStatusDialogComponent } from './home/containers/ongoing-orders/update-food-status-dialog/update-food-status-dialog.component';
import { PlaceOrderComponent } from './home/containers/place-order/place-order.component';
import { OrderMenuComponent } from './home/containers/place-order/order-menu/order-menu.component';
import { AddToCartDialogComponent } from './home/containers/place-order/order-menu/add-to-cart-dialog/add-to-cart-dialog.component';
import { OrderCartComponent } from './home/containers/place-order/order-cart/order-cart.component';
import { TableOccupancyComponent } from './home/containers/table-occupancy/table-occupancy.component';
import { NgxPrintModule } from 'ngx-print';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { OrderTypeDialogComponent } from './home/containers/table-occupancy/order-type-dialog/order-type-dialog.component';
import { OrderCartDialogComponent } from './home/containers/place-order/order-menu/order-cart-dialog/order-cart-dialog.component';
import { DashBoardComponent } from './home/containers/dash-board/dash-board.component';
import { MetaDataComponent } from './home/containers/dash-board/meta-data/meta-data.component';
import { OperationalDetailsComponent } from './home/containers/dash-board/operational-details/operational-details.component';
import { SalesComponent } from './home/containers/dash-board/sales/sales.component';
import { TableStatusComponent } from './home/containers/dash-board/table-status/table-status.component';
import { HighestSellingComponent } from './home/containers/dash-board/highest-selling/highest-selling.component';
import { RawMaterialStatusComponent } from './home/containers/dash-board/raw-material-status/raw-material-status.component';
import { SectionRevenueComponent } from './home/containers/dash-board/section-revenue/section-revenue.component';
import { OngoingOrderStatusComponent } from './home/containers/dash-board/ongoing-order-status/ongoing-order-status.component';
import { UserWiseOrderComponent } from './home/containers/dash-board/user-wise-order/user-wise-order.component';
import { PlaceOrderFilterDialogComponent } from './home/containers/place-order/order-menu/place-order-filter-dialog/place-order-filter-dialog.component';
import { ImageViewerComponent } from './home/containers/place-order/order-menu/image-viewer/image-viewer.component';
import { OrderBillDialogComponent } from './home/containers/ongoing-orders/order-bill-dialog/order-bill-dialog.component';
import { CartDeleteDialogComponent } from './home/containers/place-order/order-cart/cart-delete-dialog/cart-delete-dialog.component';
import { OngoingOrderFilterDialogComponent } from './home/containers/ongoing-orders/ongoing-order-filter-dialog/ongoing-order-filter-dialog.component';
import { PointOfSalesComponent } from './home/containers/point-of-sales/point-of-sales.component';
import { PosCartComponent } from './home/containers/point-of-sales/pos-cart/pos-cart.component';
import { PosCheckoutDialogComponent } from './home/containers/point-of-sales/pos-checkout-dialog/pos-checkout-dialog.component';
import { KitchenOrdersComponent } from './home/containers/ongoing-orders/kitchen-orders/kitchen-orders.component';
import { AllOrdersComponent } from './home/containers/ongoing-orders/all-orders/all-orders.component';
import { PosCartDialogComponent } from './home/containers/point-of-sales/pos-cart-dialog/pos-cart-dialog.component';
import { metaReducers } from './home/containers/store/clear/clear.reducer';
import { KotPrintDialogComponent } from './home/containers/place-order/order-cart/kot-print-dialog/kot-print-dialog.component';
import { AddNewFoodComponent } from './home/containers/place-order/order-menu/add-new-food/add-new-food.component';
import { KotPrinterViewComponent } from './home/containers/ongoing-orders/all-orders/kot-printer-view/kot-printer-view.component';
import { DayEndDialogComponent } from './home/components/day-end-dialog/day-end-dialog.component';
import { StartDayDialogComponent } from './home/components/start-day-dialog/start-day-dialog.component';
import { AccessDeniedComponent } from './home/components/access-denied/access-denied.component';
import { NotificationBellComponent } from './home/components/notification-bell/notification-bell.component';
import { Router } from '@angular/router';
import { PathEnum } from './@application/enum/path.enum';
import { KeycloakTokenInterceptor } from './@application/interceptors/keycloak-token.interceptor';
import { TenantInterceptor } from './@application/interceptors/tenant.interceptor';
import { GlobalErrorInterceptor } from './@application/interceptors/global-error.interceptor';
import { StorageService } from '../../projects/vendors/src/lib/services/storage.service';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    DayEndDialogComponent,
    HomeComponent,
    SystemSettingsComponent,
    OngoingOrdersComponent,
    CheckOutDialogBoxComponent,
    OrderDeleteDialogComponent,
    UpdateFoodStatusDialogComponent,
    PlaceOrderComponent,
    OrderMenuComponent,
    AddToCartDialogComponent,
    OrderCartComponent,
    TableOccupancyComponent,
    DashBoardComponent,
    MetaDataComponent,
    OperationalDetailsComponent,
    SalesComponent,
    TableStatusComponent,
    HighestSellingComponent,
    RawMaterialStatusComponent,
    SectionRevenueComponent,
    OngoingOrderStatusComponent,
    UserWiseOrderComponent,
    OrderTypeDialogComponent,
    OrderCartDialogComponent,
    PlaceOrderFilterDialogComponent,
    ImageViewerComponent,
    OrderBillDialogComponent,
    CartDeleteDialogComponent,
    OngoingOrderFilterDialogComponent,
    PointOfSalesComponent,
    PosCartComponent,
    PosCheckoutDialogComponent,
    KitchenOrdersComponent,
    AllOrdersComponent,
    PosCartDialogComponent,
    StartDayDialogComponent,
    PosCartDialogComponent,
    KotPrintDialogComponent,
    AddNewFoodComponent,
    KotPrinterViewComponent,
    AccessDeniedComponent,
    NotificationBellComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    KeycloakAngularModule,
    AuthModule,
    VendorsModule,
    FormsModule,
    HttpClientModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    NgxPrintModule,
    StoreModule.forRoot(fromApp.appReducer, { metaReducers }),
    NzTooltipDirective,
    NgxEditorModule,
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        disableClose: true,
        hasBackdrop: true,
        // Callers pass fixed px widths (350/400/550/700px); cap them so they fit a phone.
        maxWidth: '95vw',
        maxHeight: '90vh',
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, Router, StorageService],
    },
    KeycloakService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenantInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalErrorInterceptor,
      multi: true,
    },
    DatePipe,
    RawMaterialNamePipe,
    TableNamePipe,
    SectionNamePipe,
    FoodItemPipe,
    provideAnimationsAsync(),
    provideHttpClient(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

function initializeKeycloak(keycloak: KeycloakService, router: Router, storageService: StorageService) {
  return () =>
    keycloak
      .init({
        config: {
          url: 'https://identity.trangle.io/',
          realm: 'trangle',
          clientId: 'tg-smes_restaurant-pos',
        },
        initOptions: {
          onLoad: 'login-required',
          checkLoginIframe: false,
        },
        enableBearerInterceptor: true,
      })
      .then((authenticated) => {
        if (authenticated) {
          const keycloakInstance = keycloak.getKeycloakInstance();
          const token = keycloakInstance.tokenParsed;

          // Proactively refresh token when it expires (handles idle users)
          keycloakInstance.onTokenExpired = () => {
            keycloak.updateToken(30).then((refreshed) => {
              if (refreshed) {
              }
            }).catch(() => {
              console.warn('Token refresh failed — refresh token may be expired. Logging out.');
              sessionStorage.clear();
              keycloak.logout(window.location.origin);
            });
          };

          const realmRoles: string[] = token?.realm_access?.roles || [];
          const hasAccess = realmRoles.includes('tg-smes_restaurant-pos:access');

          if (!hasAccess) {
            router.navigate([PathEnum.AccessDenied]);
            return;
          }
          if (token && token['primary-tenant-id']) {
            storageService.saveToSessionStorage('tenantId', token['primary-tenant-id']);
          }

          router.navigate([PathEnum.Initializing]);
        }
      })
      .catch((err: any) => {
        console.error('Keycloak initialization failed', err);
        return Promise.resolve();
      });
}
